const state = {
  schedule: {
    list: null,
    loading: true,
    error: false
  },
  addressItems: {
    list: null,
    loading: true,
    error: false
  },
  startAvailableDate: {
    list: null,
    loading: true,
    error: false
  },

  filterDate: [],
  filterAddress: [],
  filterSearch: '',
  urlDate: {},
  availableDate: []
};

export default {
  ...state
}